
import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import Scorm from '@bob-the-builder/kb4-scorm-client';
import { mixins } from 'vue-class-component';
import { ThemeConfModule } from '@/store/modules/theme';
import { Event } from '@bob-the-builder/kb4-scorm-client/dist/src/types/LmsEvent';
import { TEST_OUT_EVENTS } from '@/constants';
const ThemeStore = getModule(ThemeConfModule, store);
const AppState = getModule(AppModule, store);



@Component
export default class Testout extends mixins(Scorm) {
  @Prop({default:true}) isFirstPage !:boolean;
  events: Event | Record<string, undefined> = {};

  public $refs!: {
    titleRef: HTMLElement;
  };

  created() {
    this.init(ThemeStore.getScormOptions);
  }
  mounted() {
    setTimeout(() => { this.$refs.titleRef.focus(); }, 500);
  }
  goToTestout () {
    this.recordEvent(TEST_OUT_EVENTS.REQUESTED);
    let bookmark = this.getBookmark();
    bookmark.testout = { usedTestout: true, failedTestout: false };  
    bookmark.biggestIndex = AppState.getTableOfContents.slides.findIndex(({ testoutprompt }) => testoutprompt),
    this.setBookmark(bookmark);
 
    AppState.setTestout(true);
    this.$emit('close-testout');
  }
  close () {
    AppState.setTestout(false);
    this.$emit('close-testout');
  }
}
